'use client';

import Image from "next/image";
import { useIsMobile } from "@/hooks/use-is-mobile";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { appConfig } from "@/app-config";

const HeaderLogo = () => {
  const t = useTranslations();
  const isMobile = useIsMobile();

  return (
    <Link
      href="/"
      aria-label="TibetMed"
      className="inline-flex items-center"
      prefetch
      title={t('home')}
    >
      <Image src={`/images/${appConfig.logoFile}`} alt="TibetMed Logo" width={178} height={30} />
    </Link>
  )
}

export default HeaderLogo;
